import React from 'react'
import { Card, Form, Select } from 'components/common'

export const DiscountPercent = ({ discountPercent }) => {
  const options = [
    { label: '1 / 2', value: 'ONE_HALF' },
    { label: '2 / 3', value: 'TWO_THIRD' },
    { label: '全額免除', value: 'FULL' },
  ]

  return (
    <Card>
      <Form.Item
        name="discountPercent"
        label="ディスカウント率"
        labelCol={{ span: 24 }}
        initialValue={
          discountPercent ? discountPercent.discountPercentLabel : options[0]
        }
        required
      >
        <Select options={options} />
      </Form.Item>
    </Card>
  )
}
